import React from "react";

export function CodeComponent({children, className}) {
    const endsWithParenthesis = typeof children === "string" && children.endsWith(")")
    return (
        <code className={(className ? className : "") + (endsWithParenthesis ? " parenthesisEnd" : "")}>
            {children}
        </code>
    )
}
